<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>Pagine</v-card-title>
        <v-row dense class="pl-2 pr-2 pb-2">
          <!-- configurations -->
          <v-col
            v-for="(item, idxD) of Object.keys(configurazione.configurations)"
            :key="item"
            cols="3"
          >
            <v-card class="mx-auto" :disabled="loading || saving">
              <v-list-item three-line dense>
                <v-list-item-icon>
                  <v-checkbox
                    v-model="configurazione.configurations[item].isChecked"
                    :disabled="configurazione.configurations[item].disabled"
                    dense
                    hide-details
                    title="Include / esclude il blocco dalle impostazioni"
                  ></v-checkbox>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    getDescriptionFromPath(['configurations', idxD]).name || ""
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    getDescriptionFromPath(['configurations', item]).description || ""
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-row class="d-flex justify-end">
                    <v-col cols="5">
                      <v-btn
                        icon
                        title="Modifica i valori"
                        v-show="editVisibile(configurazione.configurations[item])"
                      >
                        <v-icon
                          color="grey lighten-1"
                          @click="modificaValori(['configurations', item, 'config'], configurazione.configurations[item], idxD)"
                          >mdi-pencil</v-icon
                        >
                      </v-btn>
                    </v-col>
                    <v-col cols="5">
                      <v-btn
                        icon
                        title="Ulteriori informazioni"
                        v-show="configurazione.configurations[item].info"
                      >
                        <v-icon color="grey lighten-1" @click="mostraInfo(configurazione.configurations[item])"
                          >mdi-information</v-icon
                        >
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-card-title>Configurazioni</v-card-title>
        <v-row dense class="pl-2 pr-2 pb-2">
          <!-- Global config -->
          <v-col
            v-for="(item, idxD) of Object.keys(configurazione.globalConfig)"
            :key="idxD"
            cols="3"
          >
            <v-card class="mx-auto" :disabled="loading || saving">
              <v-list-item three-line dense>

                <v-list-item-content>
                  <v-list-item-title>{{ getDescriptionFromPath(['globalConfig', item]).name || "" }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    getDescriptionFromPath(['globalConfig', item]).description || ""
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-row class="d-flex justify-end">
                    <v-col cols="5">
                      <v-btn
                        icon
                        title="Modifica i valori"
                        v-show="editVisibile(configurazione.globalConfig[item])"
                      >
                        <v-icon
                          color="grey lighten-1"
                          @click="modificaValori(['globalConfig', item], configurazione.globalConfig[item], idxD)"
                          >mdi-pencil</v-icon
                        >
                      </v-btn>
                    </v-col>
                    <v-col cols="5">
                      <v-btn
                        icon
                        title="Ulteriori informazioni"
                        v-show="configurazione.globalConfig[item].info"
                      >
                        <v-icon color="grey lighten-1" @click="mostraInfo(configurazione.globalConfig[item])"
                          >mdi-information</v-icon
                        >
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-btn
          class="mt-2 mb-3"
          color="success"
          :loading="saving"
          @click.stop="onSalvaModifiche"
          >Salva modifiche</v-btn
        >
      </v-card>
      <v-dialog v-model="dialogInfo" max-width="500" :persistent="true">
        <v-card>
          <v-card-title class="text-h5">{{ dialogTitle }}</v-card-title>
          <!-- eslint-disable-next-line-->
          <v-card-text v-html="markdownInfo"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="infoConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEdit" max-width="1000" :persistent="true">
        <v-card>
          <v-card-title class="text-h5">
            {{ dialogEditTitle }}
            <v-spacer></v-spacer>
            <v-btn
              icon
              title="Ulteriori informazioni"
              v-show="itemEdit && itemEdit.info"
            >
              <v-icon color="grey lighten-1" @click="mostraInfo(itemEdit)"
                >mdi-information</v-icon
              >
            </v-btn>
          </v-card-title>
          <v-container>
            <v-row dense>
              <v-col
                v-for="(ed, idx) in Object.keys(editInfo)"
                class="pl-3 pr-3"
                cols="12"
                sm="12"
                md="6"
                :key="idx"
              >
                <p>{{ getDescriptionFromPath(evaluatePath(ed)).description || "No descrizione" }}</p>
                <card
                  :item="editInfo[ed].value"
                  :configuration="configurazione || {}"
                  :path="evaluatePath(ed)"
                  @mutate="onMutate"
                  :info="getObjectFromPath(descrizioni, evaluatePath(ed))"
                ></card>
                <!--               <template v-else-if="ed.type==='editor'">
                <v-json-editor v-model="ed.value" :options="optionsWeb" :plus="true" history @error="onErrorWeb" style="height: 100%;" ref="jsonEditor"/>
              </template> -->
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="mt-4">
            <v-spacer></v-spacer>
            <v-btn color="orange darken-1" text @click="dialogEdit = false"
              >Annulla</v-btn
            >
            <v-btn color="blue darken-1" text @click="editConfirm"
              >CONFERMA</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */
import configurazioni from "@/services/configurazioniService";
import _ from "lodash";
import descrizioni from '../spiegazione.json';
import card from "./card.vue";

export default {
  components: { card },
  props: {
    item: Object,
    refresh: Number,
  },
  data() {
    return {
      loading: false,
      saving: false,
      daSalvare: false,
      tema: {},
      initial: ['configurations'],
      configurazione: {configurations:{}, globalConfig:{}},
      globalConfig: [],
      itemEditIdx: -1,
      itemEdit: null,
      editInfo: [],
      dialogEditTitle: "",
      editPosizione: "",
      dialogEdit: false,
      dialogInfo: false,
      dialogTitle: "",
      descrizioni,
      markdownInfo: "",
      menuData: {},
      rules: {
        // required: [val => (val || '').length > 0 || 'Il campo è richiesto'],
        required: (val) => (val || "").length > 0 || "Il campo è richiesto",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        nospaces: (value) =>
          (value || "").indexOf(" ") < 0 || "Gli spazi non sono ammessi",
        numero: (value) =>
          !value || !isNaN(value) || "Il valore deve essere numerico",
        numeropositivo: (value) =>
          !value ||
          (!isNaN(value) && value > 0) ||
          "Il valore deve essere un numero positivo",
        numeropositivonullo: (value) =>
          !value ||
          (!isNaN(value) && value >= 0) ||
          "Il valore deve essere un numero maggiore o uguale zero",
      },
    };
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  },
  beforeRouteLeave(to, from, next) {
    if (this.modificheNonSalvate) {
      const answer = window.confirm(
        "Ci sono delle modifiche non salvate, confermi uscita ?"
      );
      if (!answer) return false;
    }
    next();
  },
  async mounted() {
    /*
        TODO: Verificare
        1) Da licenze backoffice, su impostazioni/totem si crea il modello.
        2) Ogni totem che viene creato (da postazioni su prerequisiti) viene ricopiato il modello e si può modificare per ciascun totem indipendentemente

      */
    const modelli = await configurazioni.getConfigurazione("totem", "modelli");
    const totem = this.item;
    this.tema = totem.tema || modelli.tema;
    this.configurazione = totem.configurazione || modelli.configurazione;
    this.globalConfig = Object.values(this.configurazione.globalConfig);
    this.globalConfig.forEach((x) => {
      x.checked = true;
      x.disabled = true;
      // TODO: Attenzione in salvataggio se global config
      x.costantTitle = "Modifica valore";
      x.config = {};
      x.config[x.name] = {
        label: x.name || x.title,
        type: x.type || "text",
        value: x.value,
        title: x.title || "",
        name: x.name,
        description: x.description,
      };
    });
  },
  computed: {
    items() {
      return this.struttura || [];
    },
    modificheNonSalvate() {
      return this.daSalvare;
    },
    mostraDeltaListino() {
      return (
        this.blocco &&
        parseFloat(this.blocco.prezzo) !== parseFloat(this.blocco.prezzoListino)
      );
    },
    /*       globalConfig() {
        return this.configurazione.globalConfig ? Object.values(this.configurazione.globalConfig) : []
      } */
  },
  methods: {
    getObjectFromPath(obj, path){
      let finalObj = JSON.parse(JSON.stringify(obj));
      console.log(obj, path)
      for(const key of path){
        finalObj = finalObj[key];
      }
      return finalObj;
    },
    getDescriptionFromPath(path){
      const parsedPath = [...path];
      // parsedPath.pop();
      let final = JSON.parse(JSON.stringify(descrizioni));
      for(const key of parsedPath){
        final = final[key]
      }
      return final || {};
    },
    evaluatePath(value){
      let newPath = [];
      if(this.initial.includes('configurations')) newPath = [value];
      return [...this.initial, ...newPath, 'value'];
    },
    onMutate({value, path}){
      this.$store.commit('SET_CONFIGURATIONS', { path, value })
    },
    editVisibile(item) {
      return !_.isEmpty(item.config);
    },
    async onSalvaModifiche() {
      const totemDb = await configurazioni.getConfigurazione("totem");
      const oldTotem = totemDb.totem.findIndex(x=>x.codice===this.item.codice);
      const newTotemConfig = this.$store.state.totem;
      totemDb.totem[oldTotem].tema = newTotemConfig.theme;
      totemDb.totem[oldTotem].configurazione = newTotemConfig.configurations;
      await configurazioni.modificaConfigurazione(totemDb);
      // totem.configurazione.globalConfig = _.cloneDeep(this.globalConfig)
      // totem.configurazione.globalConfig =
      //   totem.configurazione.globalConfig || {};
      // // TODO : continuare
      // for (let g of this.globalConfig) {
      //   switch (g.type) {
      //     case "mutiswitch":
      //       break;
      //     case "multitext":
      //       break;
      //     default:
      //       g.value = g.config.value;
      //       break;
      //   }
      //   delete g.config;
      //   delete g.costantTitle;
      //   delete g.checked;
      //   delete g.disabled;
      // }
      this.daSalvare = false;
    },
    async modificaValori(initial, item, idx) {
      this.initial = initial;
      this.itemEditIdx = idx;
      this.itemEdit = item;
      this.editInfo = item.config;
      this.dialogEditTitle = item.costantTitle || item.title || item.name;
      this.dialogEdit = true;
    },
    mostraInfo(item) {
      // TODO: Nella nuova versione installare 'marked' per il parsing dell'md
      // const html = marked.parse(item.info)
      const html = item.info;
      this.markdownInfo = html;
      this.dialogTitle = item.title;
      this.dialogInfo = true;
    },
    editConfirm() {
      // this.aggiornaValore(this.itemEdit, this.editInfo)
      this.daSalvare = true;
      this.itemEditIdx = -1;
      this.dialogEdit = false;
    },
    infoConfirm() {
      this.dialogInfo = false;
    },
    preventNav(event) {
      if (!this.modificheNonSalvate) return;
      event.preventDefault();
      event.returnValue = "";
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
